// extracted by css-extract-rspack-plugin
export default {"box":"q_5XqDB58l4e7bp1","icon":"QxMHwTTzJLkPNngW","checkbox":"bVInU1YpnFY3bqre M9x05lQXUcw6In8C","container":"X6eFciGHlt05SgJl"};